import React from "react";
import Carousel from "./Carousel";
import Card from "./Card";
import "./index.css";
import { Link } from "react-router-dom";

const services = [
  {
    id: 1,
    image: "thumbnail1.png",
    title: "Chauffeur Driven Day Trips",
    text: "Our most popular car rental service which includes the vehicle of your choice",
    link: "service_chauffaeur",
  },
  {
    id: 2,
    image: "thumbnail2.png",
    title: "Self-Drive options:",
    text: "This service is the self-drive car rental option of YOKS.",
    link: "service_selfdrive",
  },
  {
    id: 3,
    image: "thumbnail3.png",
    title: "Corporate Fleet Management",
    text: "Over the years we have built the technical capacity and managerial competencies in fleet management",
    link: "service_corperatefleet",
  },
  {
    id: 4,
    image: "thumbnail4.png",
    title: "YOKS Shuttle Services",
    text: "Whether you need to be picked up from the airport, home, school, your workers and safely transported",
    link: "service_shuttle",
  },
  {
    id: 5,
    image: "thumbnail5.svg",
    title: "Driver Personnel Outsourcing",
    text: "we have a talented pool of drivers to staff any position for short and long term.",
    link: "service_driverpersonnel",
  },
  {
    id: 6,
    image: "thumbnail6.svg",
    title: "YOKS Special Events ticketing",
    text: "Ay YOKS we host events, as well as serve as special events ticket portal. for all your event needs.",
    link: "service_eventticketing",
  },
  {
    id: 7,
    image: "thumbnail7.svg",
    title: "Security Escort",
    text: "our high value clients who may need a little extra security are provided for based on formal request .",
    url: "service_securityescort",
  },
  {
    id: 8,
    image: "thumbnail8.svg",
    title: "YOKS Tours Packages",
    text: "We have great packages tailored to suit your travel and tourism needs throughout the country.",
    url: "service_tourpackages",
  },
  {
    id: 9,
    image: "thumbnail9.svg",
    title: "Meet and Greet/Visa Arrangement",
    text: "Processing travel documentation and immigration forms, assist personnel with check-In arrangements at the Airport",
    url: "service_meet",
  },
];
const OurServices = () => {
  return (
    <div className="container mx-auto max-w-5xl my-12 ">
      <div className="flex justify-between mx-12 md:mx-0 items-center ">
        <h1 className="text-4xl font-medium">Our Services</h1>
        <Link
          to="/services"
          className="text-base text-[var(--main-color2)] font-bold"
        >
          <p className=" flex items-end gap-2">
            More Services{" "}
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="mb-1"
            >
              <path
                d="M12.3033 10.7794C12.0735 10.7794 11.865 10.6863 11.7141 10.5355C11.5633 10.3846 11.4701 10.1761 11.4701 9.94629L11.4701 3.70843L2.28603 12.8925C1.96017 13.2184 1.43338 13.2184 1.10752 12.8925C0.781663 12.5666 0.781663 12.0399 1.10752 11.714L10.2916 2.52992L4.05371 2.52989C3.59291 2.52989 3.22054 2.15751 3.22054 1.69671C3.22054 1.23592 3.593 0.863454 4.0538 0.863454L12.3034 0.863449C12.7642 0.863449 13.1365 1.2358 13.1365 1.6966L13.1365 9.94617C13.1365 10.407 12.7641 10.7794 12.3033 10.7794Z"
                fill="#181A1F"
              />
            </svg>
          </p>
        </Link>
      </div>
      <Carousel className="my-12 ">
        {services.map((service) => (
          <Card
            className=""
            key={service.id}
            image={`image/services/${service.image}`}
            title={service.title}
            text={service.text}
            link={service.link}
          />
        ))}
      </Carousel>
    </div>
  );
};

export default OurServices;
